import { render, staticRenderFns } from "./ChannelInfo.vue?vue&type=template&id=54eafcc3&scoped=true&"
import script from "./ChannelInfo.vue?vue&type=script&lang=js&"
export * from "./ChannelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eafcc3",
  null
  
)

export default component.exports